import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross-circle",
  "use": "cross-circle-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cross-circle\"><path fill-rule=\"evenodd\" d=\"M18 9c0-4.967-4.033-9-9-9S0 4.033 0 9s4.033 9 9 9 9-4.033 9-9zm-6.5-3.5L9 8 6.5 5.5a.707.707 0 1 0-1 1L8 9l-2.5 2.5a.707.707 0 0 0 1 1L9 10l2.5 2.5a.708.708 0 0 0 1-1L10 9l2.5-2.5a.708.708 0 0 0-1-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol